import React from 'react';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../../../BlockTabs';
import PieChart from '../../../charts/PieChart'
import { Loader } from '../../../components';
import { useGetPublisherExclusiveQuery } from '../../../../api/publisherAdminApiSlice';

const ExclusivePie = ({publisherId}) => {
  const { t } = useTranslation();
  const {data = {}, isSuccess, isLoading, isError} = useGetPublisherExclusiveQuery(publisherId)
  const pieDataAll = [
    {"name":"Exclusive","y":data.exclusive_active_devices},
    {"name":"Not exclusive","y":(data.active_devices - data.exclusive_active_devices)}
  ];
  const pieDataAuthorizedActive = [
    {"name":"Exclusive","y":data.exclusive_location_authorized_active_devices},
    {"name":"Not exclusive","y":(data.active_devices - data.exclusive_location_authorized_active_devices)}
  ];
  return (
    <BlockTabs title={t("publisher.general.exclusiveDevices")} defaultActiveKey="All">
      <Loader success={isSuccess} error={isError} minHeight={"100%"} title={"All"} key={"All"}>
        <PieChart data={pieDataAll} datalabels/>
      </Loader>
      <Loader success={isSuccess} error={isError} minHeight={"100%"} title={"Location authorized"} key={"Location_authorized"}>
        <PieChart data={pieDataAuthorizedActive} datalabels/>
      </Loader>
    </BlockTabs>
  )
}

export default ExclusivePie
